/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Contacts_EmptyInputs */

const en_case_chat_contacts_empty = /** @type {(inputs: Case_Chat_Contacts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contacts recorded on this case yet.`)
};

const pt_br2_case_chat_contacts_empty = /** @type {(inputs: Case_Chat_Contacts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum contato registrado neste caso ainda.`)
};

/**
* | output |
* | --- |
* | "No contacts recorded on this case yet." |
*
* @param {Case_Chat_Contacts_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_contacts_empty = /** @type {((inputs?: Case_Chat_Contacts_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Contacts_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_contacts_empty(inputs)
	return pt_br2_case_chat_contacts_empty(inputs)
});